import React, { useEffect } from 'react';
import styles from './styles.module.css';
import Text from 'components/shared/Text';
import { Checkbox, CircularProgress } from '@material-ui/core';
import Button from '../Button';
import Popup from '../Popup';

const NotificationDesktop = ({
  updateNotification,
  notification,
  updateNotificationIsRequesting,
  checkboxStyle,
  handleCheckboxChange,
  updateNotificationData,
  setupdateNotificationData,
  userID,
  openPopup,
  setopenPopup,
  handleClosePopup,
  updatedNotification,
}) => {
  const capitalizeWords = inputString => {
    return inputString.replace(/\b\w/g, match => match.toUpperCase());
  };
  useEffect(() => {
    let newNotification = [...notification];
    let activeIds = [];
    Object.values(newNotification).map(data => {
      data.notificationTypes.map(data2 => {
        if (data2.isEmailActive === true) {
          activeIds.push(data2.id);
        }
      });
    });
    setupdateNotificationData(activeIds.join(','));
    // eslint-disable-next-line
  }, []);

  const handleUpdate = () => {
    if (updateNotificationData === '') {
      return;
    } else {
      const data = {
        userId: userID.toString(),
        pushNotifications: null,
        emailNotifications: updateNotificationData.toString(),
      };
      updateNotification(data);
    }
  };

  useEffect(() => {
    if (updatedNotification.length !== 0) {
      setopenPopup(true);
    }
    // eslint-disable-next-line
  }, [updatedNotification]);

  return (
    <div className={styles.mainContainer}>
      <Popup openPopup={openPopup} handleClosePopup={handleClosePopup} />
      {notification?.map((data, index) => {
        return (
          <>
            <div
              style={
                data.headerName === 'OPERATIONAL'
                  ? { height: '170px' }
                  : data.headerName === 'MARKETING & PROMOTIONS'
                  ? { height: '330px' }
                  : data.headerName === 'CUSTOMER SERVICE \nCOMMUNICATION'
                  ? { height: '170px' }
                  : null
              }
              className={styles.wrapper1}
            >
              <div className={styles.container}>
                <div className={styles.subContainer}>
                  <Text className={styles.subHeading}>
                    {data?.headerName && capitalizeWords(data.headerName.toLowerCase())}
                  </Text>
                  <Text className={styles.subHeadingContent}>{data?.headerComment}</Text>
                </div>
                <Text className={styles.email}>Email</Text>
              </div>
              <div className={styles.divider}></div>
              {data?.notificationTypes.map((data2, index2) => {
                return (
                  <>
                    <div style={{ marginTop: 20 }} className={styles.contentWrapper}>
                      <Text className={styles.content}>{data2.notificationTypeName}</Text>
                      <div className={styles.checkboxDiv}>
                        <Checkbox
                          defaultChecked={data2.isEmailActive}
                          style={checkboxStyle}
                          onChange={e =>
                            handleCheckboxChange((data2?.id).toString(), e.target.checked)
                          }
                        />
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </>
        );
      })}
      {notification.length !== 0 && notification !== null ? (
        <div className={styles.ButtonWrapper}>
          <Button disabled={updateNotificationData === ''} onClick={() => handleUpdate()}>
            {updateNotificationIsRequesting ? (
              <CircularProgress
                size={20}
                style={{ color: 'white', marginRight: '20px' }}
              />
            ) : null}
            Save
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default NotificationDesktop;
